(function() {
  'use strict';

  var _notificacoes = [
    {
      start: new Date('2018-08-25T04:30:00Z'),
      end: new Date('2018-08-25T10:30:00Z'),
      message: 'Neste sábado, 25/08/2018, no período entre 04h30 e 07h30, realizaremos uma manutenção programada. Por isso, haverá indisponibilidade em nosso sistema. Agradecemos pela compreensão.',
      force: true,
      danger: true,
    },
    {
      start: new Date('2018-09-25T00:00:00Z'),
      end: new Date('2018-10-03T00:00:00Z'),
      message: 'A partir de 01 de outubro de 2018, '
          + 'para coletas em que nosso colaborador comparecer no local conforme agendamento e '
          + 'não houver encomendas para coletar, encomendas não estão prontas, local está fechado, '
          + 'entre outros motivos que tornem uma coleta de insucesso, haverá cobrança de taxa. '
          + '<a href="https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308946488852-Coletas-sem-sucesso">Saiba mais</a>',
      force: true,
      danger: true,
    },
    {
      start: new Date('2018-09-25T00:00:00Z'),
      end: new Date('2018-10-28T00:00:00Z'),
      message: 'Serviço de chat temporariamente indisponível. '
          + 'Para tratamento de problemas relacionados a encomendas, utilize o painel de ocorrências. '
          + 'Para solicitar atendimento, envie um e-mail para <a href="mailto:contato@mandae.com.br">contato@mandae.com.br</a>. ',
      force: true,
      danger: true,
    },
    {
      start: new Date('2018-09-25T00:00:00Z'),
      end: new Date('2019-01-02T00:00:00Z'),
      message: 'Em virtude das festas de fim de ano,'
          + ' não haverá operação nos dias 24, 25 e 31 de dezembro e 1º de janeiro.'
          + ' Nos demais dias, seguiremos com expediente normal.',
      force: true,
      danger: true,
    },
    {
      start: new Date('2019-01-24T00:00:00Z'),
      end: new Date('2019-01-26T00:00:00Z'),
      message: 'Por conta do feriado de São Paulo, amanhã dia 25/01/2019, só serão efetuadas coletas previamente agendadas.<br>'
          + 'Caso você queira solicitar coleta nesta data, por favor, entre em contato por meio do chat de atendimento para agendar.<br>'
          + 'Não se preocupe: caso você já tenha notificado nossa equipe, ela será feita normalmente.',
      force: true,
      danger: true,
    },
    {
      start: new Date('2019-02-27T00:00:00Z'),
      end: new Date('2019-03-06T00:00:00Z'),
      message: 'Em virtude do feriado de Carnaval, nos dias 4 e 5 de março as atividades na Mandaê serão suspensas.<br>'
        + 'As coletas e envios serão retomados - em período integral - no dia 6/3, quarta-feira.',
      force: true,
      danger: true,
    }
  ];

  function Notification() {
    var Notification = {};

    Notification.getNotification = function() {
      /**
       * Retorna dois parametros, o message que carrega a mensagem da notificação e o force
       * o force é um booleano para forçar a exibição mesmo que o usuário tenha fechado uma vez
       **/
      for (var i = 0; i < _notificacoes.length; ++i) {
        var n = _notificacoes[i];
        if (n.start.getTime() <= (new Date()).getTime() && n.end.getTime() >= (new Date()).getTime()) {
          return n;
        }
      }

      return {
        message: '',
        force: true
      }
    }

    return Notification;
  }

  angular
    .module('mandaeApp')
    .factory('Notification', Notification);
}());
